module.exports = __webpack_public_path__ + "img/close-menu.d0cdb3b6.svg";